import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=bedda4b8&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedda4b8')) {
      api.createRecord('bedda4b8', component.options)
    } else {
      api.reload('bedda4b8', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=bedda4b8&", function () {
      api.rerender('bedda4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iCve5ibT4ycf/JS/comp/stardisplay.vue"
export default component.exports